module.exports = __webpack_public_path__ + "img/jx3.6b4312e0.png";